import React, { useState } from 'react';
import { ModalContainer, ModalContent, Form, Label, Button, Input } from './StyledComponents';

const BirthDateModal = ({ isOpen, onSave }) => {
  const [birthDate, setBirthDate] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (birthDate) {
      onSave(birthDate);
    }
  };

  if (!isOpen) return null;

  return (
    <ModalContainer>
      <ModalContent>
        <Form onSubmit={handleSubmit}>
          <Label>Birth Date:</Label>
          <Input type="date" value={birthDate} onChange={(e) => setBirthDate(e.target.value)} />
          <Button type="submit">Save</Button>
        </Form>
      </ModalContent>
    </ModalContainer>
  );
};

export default BirthDateModal;
